module.exports = "\n<div class=\"authloader\">\n    <loading-spinner [text]=\"'Connecting Stripe to Firebase...'\"></loading-spinner> \n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/payment/connect-redirect/connect-redirect.component.html
// module id = ./src/app/payment/connect-redirect/connect-redirect.component.html
// module chunks = main